var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0L26 26L0 26L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "buscando-a-una-persona"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0L26 26L0 26L0 0Z",
    id: "Fondo",
    fill: "currentcolor",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1334 9.19125C14.1334 11.0919 12.593 12.6324 10.6923 12.6324C8.79164 12.6324 7.25117 11.0919 7.25117 9.19125C7.25117 7.29059 8.79164 5.75012 10.6923 5.75012C12.5926 5.75012 14.1334 7.29098 14.1334 9.19125L14.1334 9.19125ZM25.3279 25.3279C24.8802 25.776 24.2929 26 23.706 26C23.119 26 22.5318 25.776 22.084 25.3279C22.084 25.3279 16.241 19.4787 16.1947 19.4214C14.5598 20.4648 12.6194 21.0719 10.5359 21.0719C4.71705 21.072 0 16.3549 0 10.536C0 4.71705 4.71739 0 10.536 0C16.3546 0 21.072 4.71705 21.072 10.5359C21.072 12.6193 20.4648 14.5598 19.4214 16.1947C19.4788 16.2405 25.328 22.084 25.328 22.084C26.2241 22.9796 26.2241 24.432 25.3279 25.3279L25.3279 25.3279ZM18.8769 10.5359C18.8769 5.92943 15.1425 2.19502 10.536 2.19502C5.92949 2.19502 2.19507 5.92943 2.19507 10.5359C2.19507 13.1944 3.44034 15.5608 5.37772 17.0883C5.62968 15.2209 7.22604 13.7798 9.16257 13.7798L12.2214 13.7798C14.0784 13.7798 15.625 15.1043 15.9714 16.8596C17.7494 15.3299 18.8769 13.0652 18.8769 10.5359L18.8769 10.5359Z",
    id: "Forma",
    fill: "currentcolor",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientes);
export default __webpack_public_path__ + "static/media/clientes.c0554bf77ffca1802d9466914ae309a6.svg";
export { ForwardRef as ReactComponent };